import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Macro } from 'app/Model/ui/Macro';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';

@Component({
  selector: 'app-user-action-window',
  templateUrl: './user-action-window.component.html'
})
export class UserActionWindowComponent {
  @Input() macro: string;
  @Output() macroChange = new EventEmitter<string>();

  @Input() parameter: string;
  @Output() parameterChange = new EventEmitter<string>();

  @Input() editMode: boolean = false;
  @Output() editModeChange = new EventEmitter<boolean>();

  private _visible: boolean = false;
  @Input()
  set visible(value: boolean) {
    if (this._visible !== value) {
      this._visible = value;
      this.visibleChange.emit(this._visible);
    }
  }

  get visible(): boolean {
    return this._visible;
  }

  @Output() visibleChange = new EventEmitter<boolean>();

  @Output() onMacroSave = new EventEmitter<any>();

  fullScreen: boolean = false;

  constructor(public macroService: MacroService) {
    this.toggleFullscren = this.toggleFullscren.bind(this);
  }

  toggleFullscren() {
    this.fullScreen = !this.fullScreen;
  }

  public showWindow(macro: string, parameter: string) {
    this.macro = macro;
    this.parameter = parameter;
    this.visible = true;
  }

  saveMacro(e) {
    this.visible = false;
    this.onMacroSave.emit(e);
  }

  closePopUp(){
    this.visible = false;
  }
}
